export namespace ReferenceConst
{
  export const ChatUrl: string = 'https://akky.mx/assets/chat/chatBot-v2.html';
  export const ChatButtonId: string = 'liveagent_button_online_5738F000000GmdD';

  export const WhatsappImage: string = '/icons/Whatsapp_home.svg';
  export const Whatsappurl: string = 'https://wa.me/5218129089830';
  export const WhatsAppUrlAkkyPro: string = 'https://wa.me/528182537176';

    export const QualtricsSurveyPostPurchase: string = 'https://itesm.co1.qualtrics.com/jfe/form/SV_d5awEnNW4Dnk09E';
}
